import { IconBase, IconComponent } from './BaseIcon';

export const Minus: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M6 14.98h20v2H6z" />
  </IconBase>
);
